import { z } from "@/hooks/schema";
import { Form } from "@/components/Form";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useFormContext } from "react-hook-form";
import { PaymentFrequencyLabel } from "@/types/employeeFicha";

export const otherInfoSchema = z.object({
  payment_frequency: z.string().optional(),
  termination_date: z.string().optional(),
  participates_in_cipa: z.boolean().optional(),
  last_medical_exam_date: z.string().optional(),
});

export const OTHER_INFO_OMIT_WHEN_EMPTY = [
  "payment_frequency",
  "termination_date",
  "last_medical_exam_date",
];

export const OtherInfoStep = () => {
  const { watch, setValue } = useFormContext();
  const participatesInCipa = watch("participates_in_cipa");

  return (
    <>
      <Form.Row>
        <Form.Field name="payment_frequency">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Forma de Pagamento</Form.Label>
              <Select onValueChange={field.onChange} value={field.value}>
                <SelectTrigger>
                  <SelectValue placeholder="Selecione" />
                </SelectTrigger>
                <SelectContent>
                  {Object.entries(PaymentFrequencyLabel).map(
                    ([value, label]) => (
                      <SelectItem key={value} value={value}>
                        {label}
                      </SelectItem>
                    )
                  )}
                </SelectContent>
              </Select>
            </Form.Item>
          )}
        </Form.Field>
        <Form.Field name="termination_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Desligamento</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="last_medical_exam_date">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Último Exame Médico</Form.Label>
              <Form.Control>
                <Input {...field} type="date" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <label className="flex items-center gap-2 text-sm">
        <Checkbox
          checked={!!participatesInCipa}
          onCheckedChange={(checked) =>
            setValue("participates_in_cipa", !!checked)
          }
        />
        Participa do CIPA
      </label>
    </>
  );
};
